import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import { Observable } from "rxjs";
import { ResponseListingVacancy, ResponseOtherPICDto } from "../dto/applicant.dto";

@Injectable()
export class ApplicantSF6Api {

  private service: string = '';
  private model: string = 'sf6s/applicant';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listingVacancy(payload: ResponseListingVacancy, page: string | number, limit: string | number): Observable<ResponseListingVacancy> {
    const method: string = 'POST';
    const func: string = 'listingVacancy';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListingVacancy>(method, url, params, urlParams, body, contentType, (10 * 60) * 1000);
  }

  public listingApplicant(payload: ResponseListingVacancy, page: string | number, limit: string | number): Observable<ResponseListingVacancy> {
    const method: string = 'POST';
    const func: string = 'listingApplicant';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseListingVacancy>(method, url, params, urlParams, body, contentType, (10 * 60) * 1000);
  }

  public appAction(requestNo: string, apphistoryCode: string, applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'appAction';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof apphistoryCode !== 'undefined' && apphistoryCode !== null) urlParams.apphistoryCode = apphistoryCode;
    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public nextPIC(appStatus: string, apphistoryCode: string, applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'nextPIC';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof appStatus !== 'undefined' && appStatus !== null) urlParams.appStatus = appStatus;
    if (typeof apphistoryCode !== 'undefined' && apphistoryCode !== null) urlParams.apphistoryCode = apphistoryCode;
    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public empListVacancy(requestNo: string, catCode: string, stepFixed: boolean): Observable<any> {
    const method: string = 'GET';
    const func: string = 'empListVacancy';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof catCode !== 'undefined' && catCode !== null) urlParams.catCode = catCode;
    if (typeof stepFixed !== 'undefined' && stepFixed !== null) urlParams.stepFixed = stepFixed;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public recruitmentDetail(requestNo: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'recruitmentDetail';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json' ,(10 * 60) * 1000);
  }

  public jobApplication(apphistoryCode: string, applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'jobApplication';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof apphistoryCode !== 'undefined' && apphistoryCode !== null) urlParams.apphistoryCode = apphistoryCode;
    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public preScreening(requestNo: string, apphistoryCode: string, applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'preScreening';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof apphistoryCode !== 'undefined' && apphistoryCode !== null) urlParams.apphistoryCode = apphistoryCode;
    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public selProgress(requestNo: string, apphistoryCode: string, applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'selProgress';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;
    if (typeof apphistoryCode !== 'undefined' && apphistoryCode !== null) urlParams.apphistoryCode = apphistoryCode;
    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  saveAction(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "saveAction";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public appPersonal(applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'appPersonal';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public mainInfo(apphistoryCode: string, applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'mainInfo';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof apphistoryCode !== 'undefined' && apphistoryCode !== null) urlParams.apphistoryCode = apphistoryCode;
    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public saveJobApp(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "saveJobApp";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public saveSelProgress(formData): Observable<any> {
    const method: string = "POST";
    const func: string = "saveSelProgress";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public mediaSource(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'mediaSource';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public vacancyDetail(requestNo : string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'vacancyDetail';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  otherPIC(limit: string | number, skip: string | number, search: string): Observable<ResponseOtherPICDto> {
    const method: string = 'GET';
    const func: string = 'otherPIC';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;
    if (typeof search !== 'undefined' && search !== null) urlParams.search = search;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseOtherPICDto>(method, url, func, params, body);
  }

  public appContact(applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'appContact';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public appAddress(applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'appAddress';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public appEmergency(applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'appEmergency';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public appEducation(applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'appEducation';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public appExperience(applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'appExperience';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public appFamily(applicantId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'appFamily';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof applicantId !== 'undefined' && applicantId !== null) urlParams.applicantId = applicantId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public savePersonal(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'savePersonal';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public saveContact(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'saveContact';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public saveAddress(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'saveAddress';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public saveEmergency(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'saveEmergency';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public saveEducation(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'saveEducation';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public saveExperience(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'saveExperience';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public saveFamily(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'saveFamily';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public addAddress(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addAddress';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public addEmergency(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addEmergency';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public addEducation(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addEducation';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public addExperience(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addExperience';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public addFamily(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addFamily';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  } 

  public deleteAddress(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'deleteAddress';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public deleteEmergency(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'deleteEmergency';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public deleteEducation(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'deleteEducation';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public deleteExperience(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'deleteExperience';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public deleteFamily(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'deleteFamily';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }

  public deletePersonal(formData): Observable<any> {
    const method: string = 'POST';
    const func: string = 'deletePersonal';
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, 'json', (10 * 60) * 1000);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/applicant-sf6.api.ts